import axios from "axios";
import {ORGANIZATION_USER_ROLE_ADMIN} from "@/helper/constants";
import router from "@/router";

const state = {
    notifications: [],
    theme: 'light',
    organizations: [],
    organizationId: null,
    organizationRole: '',
    userCountry: '',
    loading: false,
    hasActiveOrganization: true,
    organizationLoaded: false,
    organizationUpdate: 0
};
const getters = {
    getNotifications: state => state.notifications,
    getTheme: state => state.theme,
    getOrganizations: state => state.organizations,
    getOrganizationId: state => state.organizationId,
    getOrganizationRole: state => state.organizationRole,
    getOrganizationName: state => {
        const organization = state.organizations.filter(organization => state.organizationId === organization.OrganizationID);
        return organization.length ? organization[0].Name : '';
    },
    getOrganizationOwnerID: state => {
        const organization = state.organizations.filter(organization => state.organizationId === organization.OrganizationID);
        return organization.length ? organization[0].OwnerID : '';
    },
    isOwner: (state, a_, b_, rootGetters) => {
        return  rootGetters.getOrganizationOwnerID === rootGetters.getUserId;
    },
    isOrganizationAdmin: state => state.organizationRole === ORGANIZATION_USER_ROLE_ADMIN,
    selectedOrganization: (state) => {
        const organization = state.organizations.filter((organization => organization.OrganizationID === state.organizationId));
        return organization.length ? {...organization[0]} : {Name: ''};
    },
    getUserCountry: state => state.userCountry,
    isLoading: state => state.loading,
    isOrganizationsLoaded: state => state.organizationLoaded,
    hasActiveOrganization: state => state.hasActiveOrganization,
    getOrganizationUpdate: state => state.organizationUpdate,
};
const actions = {
    async addNotification({commit}, notification) {
        commit('addNotification', notification);
    },
    async setTheme({commit}, theme) {
        commit('setTheme', theme);
    },
    async refreshOrganizations({commit, rootGetters}) {
        const url = rootGetters.getUrl('organizations');
        return axios.get(url).then(({data}) => {
            commit('setOrganizations', data.Result);
        });
    },
    async setOrganizations({commit}, organizations) {
        commit('setOrganizations', organizations);
        commit('setHasActiveOrganization', organizations.filter(organization => !organization.IsSubscriptionExpired).length > 0)
    },
    async setOrganizationId({commit, rootGetters}, organizationId) {
        commit('setOrganizationId', organizationId);
        if (organizationId) {
            if(rootGetters.selectedOrganization.IsSubscriptionExpired) {
                router.push({name: 'subscriptionExpired'})
            } else {
                const url = rootGetters.getOrganizationUsers(organizationId, rootGetters.getUserId);
                axios.get(url).then(({data}) => {
                    commit('setOrganizationRole', data.Result.Role);
                });
            }
        }
    },
    async removeOrganization({commit}) {
        commit('removeOrganization');
    },
    async setUserCountry({commit}, country) {
        commit('setUserCountry', country);
    },
    setLoader({commit}, loading) {
        commit('setLoader', loading);
    },
    async setHasActiveOrganization({commit}, value) {
        commit('setHasActiveOrganization', value)
    },
    async updateOrganizations({commit}) {
        commit('updateOrganizations')
    }
};
const mutations = {
    addNotification(state, notification) {
        state.notifications.push(notification);
    },
    setTheme(state, theme) {
        state.theme = theme;
    },
    setOrganizations(state, organizations) {
        state.organizations = organizations;
        state.organizationLoaded = true;
    },
    setOrganizationId(state, organizationId) {
        state.organizationId = organizationId;
    },
    setOrganizationRole(state, organizationRole) {
        state.organizationRole = organizationRole;
    },
    setUserCountry(state, country) {
        state.userCountry = country;
    },
    removeOrganization(state) {
        state.organizationRole = '';
        state.organizationId = null;
        state.organizations = [];
        state.organizationLoaded = false;
        state.hasActiveOrganization = true;
    },
    setLoader(state, loading) {
        state.loading = loading;
    },
    setHasActiveOrganization(state, value) {
        state.hasActiveOrganization = value;
    },
    updateOrganizations(state) {
        state.organizationUpdate = state.organizationUpdate  +1;
    }
};
export default {
    state,
    getters,
    actions,
    mutations
};